<div id="task" class="page-layout carded left-sidenav" style="background-color: #777770 !important;">

    <!-- TOP BACKGROUND -->
    <div fxFill style="background-color:#fafafa; z-index:1; position:absolute;"></div>
    <div class="top-bg mat-accent-bg"></div>
    <!-- / TOP BACKGROUND -->

    <mat-sidenav-container style="background-color:transparent !important;">

        <!-- SIDENAV -->
        <mat-sidenav class="sidenav" align="start" opened="true" mode="side" fuseMatSidenavHelper="carded-left-sidenav"
            mat-is-locked-open="gt-md">
            <fuse-task-main-sidenav [title]="this.getTitle()" [userReadOnly]="this.userReadOnly">
            </fuse-task-main-sidenav>
        </mat-sidenav>
        <!-- / SIDENAV -->

        <!-- CENTER -->
        <div class="center">
            <!-- CONTENT HEADER -->
            <div class="header" fxLayout="row" fxLayoutAlign="start center">
                <div class="search-wrapper mat-white-bg" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <button mat-button class="mat-icon-button sidenav-toggle"
                        fuseMatSidenavToggler="carded-left-sidenav" fxHide.gt-md aria-label="Toggle Sidenav"
                        matTooltip="View sort and filter options">
                        <mat-icon>menu</mat-icon>
                    </button>
                    <div class="search" flex fxLayout="row" fxLayoutAlign="start center"
                        matTooltip="Enter a search term to look for in the list of tasks. The search term needs to be more than 3 characters long.">
                        <mat-icon>search</mat-icon>
                        <input [formControl]="searchInput" placeholder="Search for a task"
                            aria-label="Search for a task" fxFlex>
                    </div>
                </div>

            </div>
            <!-- / CONTENT HEADER -->

            <!-- CONTENT CARD -->
            <div class="content-card mat-white-bg" [ngClass]="{'current-task-selected':currentTask}">
                <!-- CONTENT TOOLBAR -->
                <div class="toolbar px-24 py-8" *ngIf='showListToolbar'>
                    <div class="task-selection" fxFlex="row" fxLayoutAlign="start center">
                        <button mat-button [matMenuTriggerFor]="mnuSortOrder">
                            <mat-icon>sort</mat-icon>
                            <span>Sort</span>
                        </button>
                        <mat-menu #mnuSortOrder="matMenu">
                            <button mat-menu-item *ngFor="let order of this.taskService.getSortOrders()"
                                (click)="btnApplySortOrder(order)">
                                <mat-icon *ngIf="order.selected && order.order!==1">arrow_drop_down</mat-icon>
                                <mat-icon *ngIf="order.selected && order.order===1">arrow_drop_up</mat-icon>
                                <mat-icon *ngIf="!order.selected"></mat-icon>
                                <span>&nbsp;{{order.title}}</span>
                            </button>
                        </mat-menu>

                        <button mat-button [matMenuTriggerFor]="mnuFilter">
                            <mat-icon>filter_list</mat-icon>
                            <span>Filters</span>
                        </button>
                        <mat-menu #mnuFilter="matMenu">
                            <button mat-menu-item *ngFor="let filter of this.taskService.getFilters()"
                                (click)="btnApplyFilter(filter)">
                                <mat-icon>{{filter.icon}}</mat-icon>
                                {{filter.title}}&nbsp;
                                <mat-icon *ngIf='filter.selected'>done</mat-icon>
                            </button>
                        </mat-menu>
                    </div>
                </div>
                <!-- CONTENT TOOLBAR -->

                <!-- CONTENT -->
                <div class="content h-100-p" fxFlexAlign="row" fxLayoutAlign="stretch stretch">
                    <fuse-task-list fxFlex [taskSelection]='this.taskSelection' [readOnly]="userReadOnly">
                    </fuse-task-list>
                    <fuse-task-details fxFlex [bindTaskToList]='true'></fuse-task-details>
                </div>
                <!-- / CONTENT -->
            </div>
            <!-- / CONTENT CARD -->
        </div>
        <!-- / CENTER -->
    </mat-sidenav-container>
</div>